import { addQueryParams, ModalRaw, useRouter } from '@main/core-ui';
import { getUnderlyingPath } from '@main/internationalization';
import { Button } from '@main/pc-core-components';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { LogoWarning } from '../../components';
import { useLogout } from '../../hooks';
import { selectActiveDataSubject } from '../ActiveDataSubject/selectors';
import { noValidScopeMessages } from './messages';
import { NoValidScopeBody } from './wrappers';

/**
 *  The error modal to display when the user has no valid scope.
 *
 *  Redirect the user to
 *  1. Select subject modal if no data subject was previously selected
 *  2. Else, redirect to the login page
 */
export const NoValidScope: React.FC = () => {
  const { formatMessage } = useIntl();
  const logout = useLogout();
  const { queryParams, redirect, location } = useRouter();
  const dataSubject = useSelector(selectActiveDataSubject);
  const { locale } = getUnderlyingPath(location.pathname);
  const newPath = locale ? `/login/${locale}` : '/login';

  const hideModal = (): void => {
    logout();
  };

  const onConfirm = (): void => {
    logout();
    if (!dataSubject) {
      redirect(addQueryParams(location, { modal: 'select-subject' }));
    } else {
      redirect(newPath);
    }
  };

  return (
    <ModalRaw
      width="600px"
      centered
      onHide={hideModal}
      show={queryParams.modal === 'no-valid-scope'}
      footer={
        <Button buttonType="primary" onClick={onConfirm}>
          {formatMessage(noValidScopeMessages.confirm)}
        </Button>
      }
    >
      <NoValidScopeBody>
        <h3>{formatMessage(noValidScopeMessages.title)}</h3>
        <br />
        <LogoWarning />
        <p>{formatMessage(noValidScopeMessages.description)}</p>
      </NoValidScopeBody>
    </ModalRaw>
  );
};

export default NoValidScope;
